module.exports = __webpack_public_path__ + "media/dogs/dog-weight--green-3df30977.svg";